module.exports = __webpack_public_path__ + "img/mg-all.73790d2d.png";